import {
  gridGutter,
  gridGutterHalf,
  fontSize12,
  gridGutter1q1dot5
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../../js/shared/new-theme";

export const loadingStyle = `
	display: flex;
	justify-content: center;
	padding: 64px 0;
	width: 100%;
`;

export const painelContent = `
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: auto;
	z-index: 5;
`;

export const scrollMobile = `
	display: block;
	height: 100%;
	overflow: auto;
`;

export const mobilePanel = `
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	background: ${theme.palette.common.white};
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	z-index: 9999;
	padding: 60px 0 70px;
  overflow: hidden;
`;

export const mobilePanelHeader = `
  justify-content: space-between;
  padding: 14px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 5;
  background: ${theme.palette.common.white};
  box-shadow: ${theme.shadows[100]};

  .go-back {
    color: ${theme.palette.gray[600].value};
    font-weight: bold;
  }
`;

export const mobilePanelFooter = `
  padding: ${gridGutterHalf}px ${gridGutter}px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 4;
  background: ${theme.palette.common.white};
  align-items: center;

  button {
    padding: 0;
    min-width: 128px;
    height: 36px;
    font-size: ${fontSize12};
    border-width: 1px;
    flex: 1;
    width: 100%;
  }
  &.finished {
    width: 100%;
    justify-content: center;
    padding: ${gridGutterHalf}px ${gridGutter + gridGutter1q1dot5}px;
    a {
      width: 100%;
      text-align: center;
    }
    button {
      width: 100%;
      max-width: 300px;
    }
  }
`;

export const bonusStyle = `
  padding: ${gridGutter1q1dot5}px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

	p {
		color: ${theme.palette.gray[600].value};
		font-weight: 800;
    margin: 0;

		span {
			border-radius: 4px;
			background-color: ${theme.palette.red[100].value};
			color: ${theme.palette.common.white};
			padding: 3px 8px;
			font-size: 12px;
			font-weight: 600;
			text-transform: none;
			margin-left: 5px;
		}
  }
  
  .offers-arrow-right {
    color: ${theme.palette.green[600].value};
  }
`;
